<!--
 * @Author: Soul
 * @Date: 2021-06-25 17:23:14
 * @LastEditors: soul(佘家骏) 
 * @LastEditTime: 2022-05-10 14:05:08
 * @Description: file content
-->
<template>
  <div class="bg">
    <!-- 右侧导航 -->
    <div class="group-btn">
      <div class="btn-item" @click="goRule">活动规则</div>
      <div class="btn-item" @click="goPrize">我的礼品</div>
      <!-- <div class="btn-item" @click="getFriend">我的好友</div>
      <div class="btn-item" @click="getRanking">排行榜</div> -->
    </div>
    <BaseImg :option="{
      style: {
        margin: '12px 0 0 16px',
        alignSelf: 'flex-start',
        width: '89px',
      },
      url: 'logo.png',
    }"/>
    <!-- 人数 -->
    <div class="person-number">
      <div class="number-box">
        <span>围观人数</span>
        <span>{{ (actInfo.visitTotal * multiple) || 0 }}</span>
      </div>
      <div class="number-box">
        <span>参与人数</span>
        <span>{{ (actInfo.joinTotal * multiple) || 0 }}</span>
      </div>
    </div>
    <!-- 倒计时 -->
    <div class="endTime" >
      <label v-if="timeStatus === 1">距离活动开始还剩</label>
      <label v-if="timeStatus === 2">距离活动结束还剩</label>
      <label v-if="timeStatus === 3">游戏模块已结束<br />签约好礼进行中</label>
      <label v-if="timeStatus === 1 || timeStatus === 2" class="time">
        <span>{{ countTime.d | formatTime }}</span
        >天<span>{{ countTime.h | formatTime }}</span
        >时<span>{{ countTime.m | formatTime }}</span
        >分
      </label>
    </div>
    <div class="act-box">
      <div class="game-box" @click="goGame"></div>
      <BaseImg :option="{
        style: {
          margin: '4px auto 0',
          width: '173px',
        },
        url: 'index_img2.png',
      }" @click="goShareIndex"/>
      <BaseImg :option="{
        style: {
          margin: '4px auto 0',
          width: '173px',
        },
        url: 'index_img3.png',
      }"  @click="getRanking"/>
      <BaseImg :option="{
        style: {
          margin: '4px auto 0',
          width: '173px',
        },
        url: 'index_img4.png',
      }" @click="goCoupon"/>
      <BaseImg :option="{
        style: {
          margin: '4px auto 0',
          width: '173px',
        },
        url: 'index_img5.png',
      }"  @click="goKey"/>
    </div>
    <BaseImg :option="{
      style: {
        margin: '12px auto 0',
      },
      url: 'index_img6.png',
    }"/>
    <div class="owner-box">
      <BaseImg :option="{
        url: 'index_img7.png',
      }"/>
      <div class="owner-txt">
        活动期间成交的客户，除了享受现场签约好礼外（5月8日14:00）还可参与线上抽奖
        <span class="tips1">戴森净化器，华为65寸超薄电视 米家扫地机器人等大奖</span>
        <span class="tips2">更有罗莱家纺四件套、张小泉刀具套装、九阳空气炸锅等惊喜好礼！</span>
        <span class="tips3">活动时间：4月15日-5月8日</span>
      </div>
    </div>
    

    <!-- 项目展示 -->
    <div class="pro-box" :class="{big: addressIndex == 1}">
      <div class="pro-nav">
        <div class="nav" v-for="(item, index) in addressList" :key="index + 'address'" @click="chooseAddress(item.name)" :class="{active: addressIndex === index}">{{item.name}}</div>
      </div>
      <div class="pro-card">
        <div class="pro-item" v-for="(item, index) in chooseBuildList" :key="index + 'img'">
          <div class="pro-l" :class="{choose: item.path}" @click="goUrl(item)">
            <img :src="`${imgHost}${item.imgFile}project${item.picId}.png?v=${$config.OSSVersion}`">
            <div class="project-xcx" v-if="item.ghId">
              <wx-open-launch-weapp
                id="launch-btn"
                :username="item.ghId"
                :path="item.path"
                @error="infoClick(7)"
                @launch="infoClick(7)"
              >
              <script type="text/wxtag-template">
                <style>
                  .xcx{
                    width: 287px;
                    height: 162px;
                    opacity:0;
                  }
                </style>
                <div class="xcx"></div>
              </script>
              </wx-open-launch-weapp>
            </div>
          </div>
          <div class="pro-name">
            <span>{{item.name}}</span>
            <div class="line"></div>
          </div>
          <div class="pro-r">
            <div class="pro_txt">{{item.txt1}}</div>
            <div class="pro_txt" v-if="item.txt2">{{item.txt2}}</div>
            <div class="pro_txt" v-if="item.txt3">{{item.txt3}}</div>
            <div class="pro_txt" v-if="item.txt4">{{item.txt4}}</div>
            <!-- <div class="pro-img">
              <img :src="imgHost + 'pro-txt.png'">
            </div> -->
            <div class="pro-btn">
              <div @click="clickNav(item.name, item.position)">一键导航</div>
              <div @click="clickCall(item.tel)">一键拨号</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 我要推荐 一折抢购 -->
    <div class="btn-layer">
      <div @click="goShare" class="left act_animate_shake_seesaw_config"></div>
    </div>
    <BasePaySuccess></BasePaySuccess>
  </div>
</template>

<script>
import { MessageBox, Indicator } from "mint-ui";
import Vue from "vue/dist/vue.js";
export default {
  components: {
  },
  data() {
    return {
      countTime: {
        d: 0,
        h: 0,
        m: 0,
        s: 0,
      }, // 倒计时
      actInfo: [], // 活动信息
      timeStatus: 0, // 活动时间状态
      user: {}, // 分享人信息
      multiple: 1, // 活动人数倍率
      addressIndex: 0,
      addressList: [
        {
          name: '景德镇',
          city: ['景德镇'],
          key: 1
        },
        {
          name: '宁波',
          city: ['宁波'],
          key: 2
        },
        {
          name: '常熟',
          city: ['常熟'],
          key: 3
        },
        {
          name: '上海',
          city: ['上海'],
          key: 4
        },
        {
          name: '常州',
          city: ['常州'],
          key: 5
        },
        {
          name: '南京',
          city: ['南京'],
          key: 6
        },
        {
          name: '无锡',
          city: ['无锡'],
          key: 7
        },
        {
          name: '宜兴',
          city: ['宜兴'],
          key: 8
        },
        {
          name: '台州',
          city: ['台州'],
          key: 9
        },
        {
          name: '海口',
          city: ['海口'],
          key: 10
        },
      ],
      buildList: [
        {
          picId: 1,
          key: 1,
          imgFile: '',
          city: ['景德镇'],
          name: '景德镇宝龙世家',
          address: '景德镇市昌江区经七路与纬三路交叉口',
          txt1: '景德镇昌南里·百树旁',
          txt2: '32万方城央公园金装住区',
          tel: '0798—8518686',
          position: '117.15075,29.277696',
          path: '',
          ghId: ''
        },
        {
          picId: 2,
          key: 2,
          imgFile: '',
          city: ['宁波'],
          name: '文创甬江城',
          address: '宁波市江北区大庆北路（中兴大桥东侧）文创甬江城营销中心',
          txt1: '三江口，均价33800元/平（仅限26号楼）',
          txt2: '南向一线观江席',
          tel: '0574-88191888',
          position: '121.588536,29.899053',
          path: '',
          ghId: ''
        },
        {
          picId: 3,
          key: 2,
          imgFile: '',
          city: ['宁波'],
          name: '奉化宝龙东腾璟庭',
          address: '宁波市奉化区华元欢乐城一楼东腾璟庭营销中心',
          txt1: '地铁口即家门口',
          txt2: '7#清楼季限时钜惠83折',
          tel: '0574-88901666',
          position: '121.429424,29.670662',
          path: '',
          ghId: ''
        },
        {
          picId: 4,
          key: 2,
          imgFile: '',
          city: ['宁波'],
          name: '宝龙TOD奉甬新城',
          address: '宁波市奉化区金海路与圆峰路交口宝龙TOD奉甬新城营销中心',
          txt1: '清盘倒计时，首付36万起',
          txt2: '抢住地铁口三房',
          tel: '0574-88668888',
          position: '121.443553,29.653064',
          path: '',
          ghId: ''
        },
        {
          picId: 5,
          key: 3,
          imgFile: '',
          city: ['常熟'],
          name: '常熟宝龙广场',
          address: '常熟市商城中路18号（国际服装城北侧）',
          txt1: '总价104万起精品小户',
          txt2: '23万方城市综合体',
          tel: '0512-89886999',
          position: '120.742995,31.62088',
          path: '',
          ghId: ''
        },
        {
          picId: 6,
          key: 4,
          imgFile: '',
          city: ['上海'],
          name: '奉发宝龙广场',
          address: '上海市临港新片区港坤路与港佳路交叉口',
          txt1: '总价197万起全能三房',
          txt2: '临港22万方城市综合体',
          tel: '18221120770',
          position: '121.735803,30.93294',
          path: '',
          ghId: ''
        },
        {
          picId: 7,
          key: 5,
          imgFile: '',
          city: ['常州'],
          name: '常州宝龙广场',
          address: '常州市钟楼区水杉路宝龙城市广场营销中心',
          txt1: '常州钟楼新城核心，青枫公园对面',
          txt2: '16万方宝龙广场，总价26万起创新小户型',
          tel: '0519-83283888',
          position: '119.89679,31.79327',
          path: '',
          ghId: ''
        },
        {
          picId: 8,
          key: 6,
          imgFile: '',
          city: ['南京'],
          name: '新生圩宝龙广场',
          address: '南京市栖霞区仙新路与恒发路交汇处新生圩宝龙广场营销中心',
          txt1: '栖霞正核，综合体住宅',
          txt2: '地铁6号线上盖，自带mall',
          tel: '025-85777888',
          position: '118.892505,32.137003',
          path: '',
          ghId: ''
        },
        {
          picId: 9,
          key: 7,
          imgFile: '',
          city: ['无锡'],
          name: '宝龙·TOD未来新城',
          address: '无锡市新吴区长江南路与新华路交汇处（宝龙世家营销中心）',
          txt1: 'TOD大城·双地铁口·宝龙商业旁',
          txt2: '建面约35㎡起全能珑寓',
          tel: '0510-81859999',
          position: '120.395824,31.503565',
          path: '',
          ghId: ''
        },
        {
          picId: 10,
          key: 8,
          imgFile: '',
          city: ['宜兴'],
          name: '龙运天城宝龙世家',
          address: '宜兴市丁蜀镇陶都路与东坡西路交汇处',
          txt1: '宜兴宝龙广场旁',
          txt2: '6层低密阔景洋房收官在即',
          tel: '0510-80335888',
          position: '119.834207,31.26987',
          path: '',
          ghId: ''
        },
        {
          picId: 11,
          key: 9,
          imgFile: '',
          city: ['台州'],
          name: '温岭云樾珑湾',
          address: '温岭市城西街道宝龙广场1号门云樾珑湾展厅（星巴克旁）',
          txt1: '一席争藏',
          txt2: '入主九龙湖',
          tel: '0576-85389999',
          position: '121.341883,28.403714',
          path: '',
          ghId: ''
        },
        {
          picId: 12,
          key: 10,
          imgFile: '',
          city: ['海口'],
          name: '海口宝龙城',
          address: '海口市西海岸长影奇幻乐园旁',
          txt1: '自贸港省会.西海岸',
          txt2: '国际大城 未来社区',
          tel: '0898-36690111',
          position: '110.192394,19.978859',
          path: '',
          ghId: ''
        },
      ],
      chooseBuildList: [],
    };
  },
  filters: {
    formatTime: function (value) {
      return value < 10 ? "0" + value : value;
    }
  },
  watch: {},
  computed:{
  },
  methods: {
    chooseAddress(name = '景德镇') {
      this.chooseBuildList = [...this.buildList].filter(v => v.city.includes(name))
      this.addressIndex = this.addressList.findIndex(v => v.city.includes(name))
      // this.addressIndex = this.addressList.findIndex(v => v.name === name)
      // this.chooseBuildList = [...this.buildList].filter(v => v.city === name)
      if (this.addressIndex < 0) {
        this.chooseAddress()
      }
    },
    // 页面埋点
    infoClick(sceneKey) {
      this.$httpdf.get(this.apiHost + 'info/click', { sceneKey: sceneKey })
    },
    //ip定位
    async getLocationByIp() {
      Vue.prototype.$infoId = undefined
      this.$util.cookie.remove('infoId')
      Indicator.open({
        text: "加载中...",
        spinnerType: "fading-circle",
      });
      let that = this;
      const data = await this.$httpdf.get(this.apiHost + 'user/getLocationByIp')
      Indicator.close();
      if (data.code == 0) {
        if (!data.data.curLocation) {
          //本地测试用====================================>>>>>
          // that.localCity = that.$root.curLocation.location;
          // that.isLocation = true;  //默认在区域内
          //<<<<<=============================================

          //如果没有curLocation，说明ip定位失败，调取gps定位
          await that.getLocationByGps();
        } else {
          Vue.prototype.$infoId = data.data.curLocation.infoId;
          Vue.prototype.$curLocation = data.data.curLocation.location;
          this.$util.cookie.set("infoId", this.$infoId, {
            expires: 60,
          });
          this.$util.cookie.set("curLocation", this.$curLocation, {
            expires: 60,
          });
          console.log(
            `当前城市名称--->${data.data.curLocation.location}-----当前infoId--->${data.data.curLocation.infoId}`
          );
        }
      } else {
        MessageBox.alert(data.msg)
      }
    },
    //gps定位
    async getLocationByGps() {
      //  let res = { latitude: 30.585323333740234, longitude: 114.36740112304688 };
      let that = this;
      that.$wx.ready(() => {
        that.$wx.getLocation().then((res) => {
          Indicator.open({
            text: "加载中...",
            spinnerType: "fading-circle",
          });
          console.log("$wx.getLocation", res);
          // let url = `${that.$apidf.xc_voice_purchase.getLocationByGps}?latitude=${res.latitude}&longitude=${res.longitude}&fromOpenId=${that.$fopenid}&openId=${that.$openid}`;
          that.$httpdf
            .get(
              this.apiHost + 'user/getLocationByGps',
              {
                fromOpenId: this.$fopenid, //有就传，用于保存浏览记录
                openId: this.$openid,
                latitude: res.latitude,
                longitude: res.longitude,
              }
            )
            .then( async (data) => {
              Indicator.close();
              console.log("getLocationByGps---", data);
              if (data.code != 0) {
                that.$showModal("不在活动区域内");
              } else {
                console.log("GPS调取成功！");
                if (!data.data.curLocation) {
                  that.$showModal("不在活动区域内");
                  return;
                }
                Vue.prototype.$infoId = data.data.curLocation.infoId;
                Vue.prototype.$curLocation = data.data.curLocation.location;
                this.$util.cookie.set("infoId", this.$infoId, {
                  expires: 60,
                });
                this.$util.cookie.set("curLocation", this.$curLocation, {
                  expires: 60,
                });
                console.log(
                  `当前城市名称--->${data.data.curLocation.location}-----当前infoId--->${data.data.curLocation.infoId}`
                );
              }
            });
        });
      });
    },
    // 参与游戏
    async getParticipate () {
      const data = await this.$httpdf.post(this.apiHost + 'user/participate')
      if (data.code == 0) {
        Vue.prototype.$key = data.data.nonceStr
        this.$util.cookie.set("key", this.$key, {
          expires: 60,
        });
        if (data.data.mobile) {
          Vue.prototype.$mobile = data.data.mobile
          this.$util.cookie.set("mobile", this.$mobile, {
            expires: 60,
          });
        } else {
          Vue.prototype.$mobile = undefined
          this.$util.cookie.remove('mobile')
        }
      }
    },
    // 倒计时
    mathTime() {
      //获取当前时间
      var now = new Date().getTime()
      //设置截止时间
      var start = this.actInfo.startTime;
      var end = this.actInfo.endTime;
      let leftTime = 0
      if (start >= now) {
        this.timeStatus = 1
        leftTime = start - now;
      } else if (now <= end){
        this.timeStatus = 2
        leftTime = end - now;
      } else {
        this.timeStatus = 3
      }
      //定义变量 d,h,m,s保存倒计时的时间
      if (leftTime >= 0) {
        this.countTime.d = Math.floor(leftTime / 1000 / 60 / 60 / 24);
        this.countTime.h = Math.floor((leftTime / 1000 / 60 / 60) % 24);
        this.countTime.m = Math.floor((leftTime / 1000 / 60) % 60);
        this.countTime.s = Math.floor((leftTime / 1000) % 60);
      }
      //递归每秒调用mathTime方法，显示动态时间效果
      setTimeout(this.mathTime, 1000);
    },
    goShareIndex() {
      if(this.timeStatus === 1){
        MessageBox.alert("活动未开始！");
        return
      } else if (this.timeStatus === 3){
        MessageBox.alert("活动已结束！");
        return
      }
      if (!this.$infoId) {
        return this.$showModal("不在活动区域内");
      }
      this.goShare()
    },
    //我要点亮
    goGame() {
      this.infoClick(4)
      if(this.timeStatus === 1){
        MessageBox.alert("活动未开始！");
        return
      } else if (this.timeStatus === 3){
        MessageBox.alert("活动已结束！");
        return
      }
      if (!this.$infoId) {
        return this.$showModal("不在活动区域内");
      }
      this.$goPage("game");
    },
    // 活动规则
    goRule() {
      this.infoClick(5)
      this.$goPage("rules");
    },
    // 我的奖品
    goPrize() {
      this.$goPage("myprize");
    },
    //我的好友
    getFriend() {
      this.infoClick(6)
      this.$goPage("myFriends");
    },
    //排行榜
    getRanking() {
      this.infoClick(10)
      this.$goPage("ranking");
    },
    // 业主专享
    goKey() {
      let beginDate = new Date('2022/05/10 23:59:59').getTime()
      if( new Date().getTime() > beginDate ){
        MessageBox.alert("活动已结束，中奖用户领奖请查看【我的奖品】");
        return
      }
      this.$goPage("key");
    },
    // 跳转组团页面
    goCoupon() {
      if(this.timeStatus === 1){
        MessageBox.alert("活动未开始！");
        return
      } else if (this.timeStatus === 3){
        MessageBox.alert("活动已结束！");
        return
      }
      if (!this.$infoId) {
        return this.$showModal("不在活动区域内");
      }
      this.$goPage("coupon");
    },
    // 点击一键导航
    clickNav(address, coordinate) {
      this.infoClick(2)
      if (!address || !coordinate) {
        this.$showModal("没有地址或地址不正确");
        return;
      }
      this.$util.redirectTo(
        `https://uri.amap.com/marker?position=${coordinate}&name=${address}&src=mypage&coordinate=gaode&callnative=0`
      );
    },
    // 点击一键拨号
    clickCall(phone) {
      this.infoClick(1)
      this.$util.makePhoneCall(phone);
    },
    //获取活动信息
    showActInfo() {
      this.$httpdf
        .get(this.apiHost + 'info/actInfo')
        .then((data) => {
          this.actInfo = data.data;
          this.mathTime(); //倒计时
        });
    },
    // 获取助力活动
    async isPopUpPrize(){
      Vue.prototype.$showPop = true
      const data2 = await this.$httpdf.get(this.apiHost + 'lucky/prize/getTelFarePrizeId')
      const data = await this.$httpdf.get(this.apiHost + 'assistance/isPopUpPrize', { prizeId: data2.data })
      if (data.code === 0) {
        this.user = data.data
        this.$modal.drawForm.alert({ prizeId: data2.data, user: this.user })
      }
    },
  },
  async created() {
    this.showActInfo()
    await this.getLocationByIp(); //首先ip定位
    await this.getParticipate()
    this.chooseAddress(this.$curLocation)
    setTimeout(()=> {
      this.$showPop || this.isPopUpPrize()
    }, 3000)
  },
  async mounted() {
  },
};
</script>

<style lang="scss" scoped>
.bg {
  padding-bottom: 169px;
  background: url( $imgHost + 'icon2.png?v=' + $OSSVersion) 258px bottom / 114px 146px no-repeat, url( $imgHost + 'index_top.png?v=' + $OSSVersion) 0 0 / 100% no-repeat, linear-gradient(0deg, #F9E5C7 0%, #FFC674 100%);
  // 右侧导航
  .group-btn {
    position: absolute;
    right: 0;
    top: 224px;
    z-index: 99;
    .btn-item {
      width: 57px;
      height: 20px;
      background: linear-gradient(90deg, #FC9F32 0%, #ff7012 100%);
      border-radius: 10px 0px 0px 10px;
      padding-left: 5px;
      font-size: 12px;
      font-family: PingFang;
      font-weight: bold;
      color: #FFFFFF;
      margin-bottom: 10px;
      @extend .flex-center-center;
    }
  }
  // 人数
  .person-number {
    margin-top: 6px;
    display: flex;
    justify-content: space-between;
    padding: 0 16px;
    width: 100%;
    position: relative;
    z-index: 2;
    .number-box {
      width: 110px;
      height: 18px;
      @extend .flex-center-center;
      color: rgba(255, 255, 255, 1);
      font-size: 12px;
      background: rgba(0, 0, 0, .5);
      border-radius: 9px;
      text-align: center;
      span {
        &+span {
          margin-left: 5px;
        }
      }
    }
  }
  // 活动倒计时
  .endTime {
    margin-top: 235px;
    width: 100%;
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #DF4E1C;
    line-height: 28px;
    position: relative;
    z-index: 2;
    text-align: center;
    span {
      display: inline-block;
      font-size: 16px;
      margin: 0 3px;
      color: #fff;
      font-weight: bold;
      width: 32px;
      height: 37px;
      line-height: 31px;
      background: url( $imgHost + 'time-bg.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    }
    label {
      // display: block;
    }
  }
  // 活动列表
  .act-box {
    width: 100%;
    padding: 0 calc((100vw - 354px) / 2);
    display: flex;
    flex-flow: row wrap;
    align-items: center;
    justify-content: space-around;
    .game-box {
      width: 354px;
      height: 151px;
      background: url( $imgHost + 'index_img1.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
      margin: 9px auto 0;
      position: relative;
      &::after {
        display: block;
        content: '';
        width: 40px;
        height: 33px;
        background: url('https://assets.rurushishi.com/activies/common/hand1.png') center / 100% no-repeat;
        position: absolute;
        bottom: 20px;
        right: 20px;
        animation: twinkle 1s infinite linear;
        z-index: 10;
      }
    }
  }
  // 业主专享
  .owner-box {
    margin-top: 19px;
    position: relative;
    width: 100%;
    .owner-txt {
      position: absolute;
      left: 50%;
      top: 0;
      transform: translateX(-50%);
      width: 375px;
      padding: 140px 50px 0;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      color: #333333;
      line-height: 19px;
      text-align: center;
      display: flex;
      flex-flow: column nowrap;
      align-items: center;
    }
    .tips1 {
      margin-top: 10px;
      padding: 0 30px;
      font-size: 15px;
      font-weight: bold;
      color: #ff7012;
    }
    .tips2 {
      padding: 0 28px;
      font-weight: bold;
      color: #ff7012;
    }
    .tips3 {
      margin-top: 10px;
      font-size: 11px;
      color: #ff9413;
    }
  }
  .pro-box {
    margin-top: 19px;
    position: relative;
    width: 343px;
    height: 587px;
    padding: 114px 0 0;
    background: url( $imgHost + 'project-bg.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    &.big {
      height: 1307px;
      background: url( $imgHost + 'project-bg2.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    }
    &::after {
      content: '';
      position: absolute;
      right: -16px;
      bottom: 3px;
      width: 95px;
      height: 83px;
      background: url( $imgHost + 'icon1.png?v' + $OSSVersion) 0 0 / 100% no-repeat;
      z-index: 3;
    }
    .pro-nav {
      position: relative;
      display: flex;
      flex-flow: row wrap;
      align-items: center;
      // justify-content: space-around;
      padding: 0 8px;
      .nav {
        margin-top: 10px;
        margin-left: 11px;
        width: 68px;
        height: 24px;
        background: #FFF2E2;
        border-radius: 12px;
        @extend .flex-center-center;
        font-size: 14px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #ff7012;
        @extend .flex-center-center;
        &:nth-of-type(4n) {
          margin-right: unset;
        }
        &.active {
          color: #FFFFFF;
          background: linear-gradient(90deg, #FC9F32 0%, #ff7012 100%);
        }
      }
    }
    .pro-card {
      margin-top: 12px;
      padding: 0 12px;
      .pro-btn {
        margin-top: 15px;
        width: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        div {
          width: 74px;
          height: 24px;
          border: 1px solid #ff7012;
          border-radius: 12px;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ff7012;
          line-height: 18px;
          text-align: center;
          @extend .flex-center-center;
          &+div {
            margin-left: 16px;
          }
        }
      }
    }
    .pro-item {
      display: flex;
      align-items: center;
      flex-flow: column nowrap;
      position: relative;
      z-index: 2;
      padding: 20px 16px 25px;
      background: linear-gradient(180deg, #FFD9BA 0%, #FEF1DB 100%);
      box-shadow: 0px 4px 6px 0px rgba(201, 79, 13, 0.38);
      border-radius: 8px;
      &+.pro-item {
        margin-top: 18px;
      }
      .pro-name {
        margin-top: 20px;
        position: relative;
        font-size: 18px;
        font-family: Source Han Sans CN;
        font-weight: bold;
        color: #ff7012;
        display: flex;
        justify-content: center;
        span {
          position: relative;
          z-index: 2;
        }
        .line {
          position: absolute;
          bottom: -2px;
          width: 120%;
          height: 6px;
          background: #FFDB9C;
          border-radius: 3px;
        }
      }
      .pro-l {
        // margin-top: 15px;
        width: 287px;
        flex: 1;
        position: relative;
        &.choose {
          &::after {
            display: block;
            content: '';
            width: 28px;
            height: 33px;
            background: url('https://assets.rurushishi.com/activies/hlb-purchase-20210129/click.png') center / 100% no-repeat;
            position: absolute;
            bottom: 0;
            right: 0;
            animation: twinkle 1s infinite linear;
            z-index: 10;
          }
        }
        .project-xcx {
          position: absolute;
          top: 0;
          bottom: 0;
          left: 0;
          right: 0;
          z-index: 3;
        }
      }
      .pro-r {
        margin-top: 15px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .pro_txt {
          position: relative;
          font-size: 14px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #333333;
          line-height: 20px;
        }
      }
    }
    .pro-img {
      width: 279px;
      margin: 18px auto;
    }
  }
  
  //我要推荐 一折抢购
  .btn-layer {
    position: fixed;
    bottom: 30px;
    left: 0;
    width: 100%;
    display: flex;
    justify-content: space-around;
    z-index: 99;
    .left {
      width: 260px;
      height: 53px;
      background: url( $imgHost + 'index_btn.png?v=' + $OSSVersion) 0 0 / 100% no-repeat;
    }
  }
}
</style>
